import { BodyText, FlexColumn, FlexRow, SvgIcon } from '@make-software/cspr-design';
import { ExtendedOffersResponse } from 'app/console-api/offers/offers-extended';
import React from 'react';
import { BoldText, StyledStatusElement } from 'app/components/common/table/styled-elements';
import {
  StatsLink,
  StyledCardRow,
  StyledSvgIcon,
  StyledTableData,
  StyledTooltip,
} from 'app/components/common/common-styles';
import { TaskShortPreview } from 'app/components/management/apps/deals/view/task-short-preview';
import { formatDatetimeFull, formatDatetimeShort } from 'app/components/utils/measures-format';
import ViewIcon from 'assets/icons/ic-view.svg';
import EditIcon from 'assets/icons/ic-edit.svg';
import LinkIcon from 'assets/icons/ic-link.svg';
import { PluginChip } from 'app/components/management/common/plugins/plugin-chip/plugin-chip';
import {DealTradeChip} from 'app/components/common/deal-trade-type/deal-trade-chip';

export interface MyOffersListItemProps {
  offer: ExtendedOffersResponse;
  onView: (offer: ExtendedOffersResponse) => void;
  onEdit: (offer: ExtendedOffersResponse) => void;
  onStatistics?: (taskID: string) => void;
}

export const MyOffersListItem = (props: MyOffersListItemProps) => {
  const onViewOffer = () => {
    props.onView(props.offer);
  };
  const onEditOffer = () => {
    props.onEdit(props.offer);
  };
  const handleOnStatistics = () => {
    if (props.onStatistics) {
      props.onStatistics(props.offer.offer.id);
    }
  };

  return (
    <StyledCardRow key={props.offer.offer.id}>
      <StyledTableData>
        <TaskShortPreview
          name={props.offer.offer.name}
          description={props.offer.offer.description}
        />
      </StyledTableData>
      <StyledTableData>
        <FlexColumn>
          <FlexRow gap={8}>
            <BodyText size={3} scale={'sm'} variation={'darkGray'}>
              Status:
            </BodyText>
            <FlexRow gap={4}>
              <BoldText size={3} monotype>
                {props.offer.offer.isActive ? (
                  <StyledStatusElement name={'Active'} isActive={true} />
                ) : (
                  <StyledStatusElement name={'Inactive'} isActive={false} />
                )}
              </BoldText>
            </FlexRow>
          </FlexRow>
          {props.offer.plugin && (
            <FlexRow gap={8}>
              <BodyText size={3} scale={'sm'} variation={'darkGray'}>
                Offer Type:
              </BodyText>
              <PluginChip id={props.offer.plugin.id}></PluginChip>
            </FlexRow>
          )}
          <FlexRow gap={8} align={'center'}>
            <BodyText size={3} scale={'sm'} variation={'darkGray'}>
              Deal Type:
            </BodyText>
            <FlexRow gap={4}>
              <DealTradeChip type={props.offer.offer.tradeType}/>
            </FlexRow>
          </FlexRow>
        </FlexColumn>
      </StyledTableData>
      <StyledTableData>
        {props.offer.offer.minQuota != 0 && (
          <FlexRow gap={8}>
            <BodyText size={3} scale={'sm'} variation={'darkGray'}>
              Min Quota:
            </BodyText>
            <BodyText size={3} scale={'sm'}>
              {props.offer.offer.minQuota}
            </BodyText>
          </FlexRow>
        )}
        <FlexRow gap={12}>
          <BodyText size={3} scale={'sm'} variation={'darkGray'}>
            Created:
          </BodyText>
          <StyledTooltip tooltipContent={formatDatetimeFull(props.offer.offer.createdAt)}>
            <BodyText size={3} scale={'sm'}>
              {formatDatetimeShort(props.offer.offer.createdAt)}
            </BodyText>
          </StyledTooltip>
        </FlexRow>
        <FlexRow gap={8}>
          <BodyText size={3} scale={'sm'} variation={'darkGray'}>
            Updated:
          </BodyText>
          <StyledTooltip tooltipContent={formatDatetimeFull(props.offer.offer.updatedAt)}>
            <BodyText size={3} scale={'sm'}>
              {formatDatetimeShort(props.offer.offer.updatedAt)}
            </BodyText>
          </StyledTooltip>
        </FlexRow>
      </StyledTableData>
      <StyledTableData>
        <FlexRow gap={21}>
          <BodyText size={3} scale={'sm'} variation={'darkGray'}>
            Active Deals:
          </BodyText>
          <BodyText size={3} scale={'sm'}>
            {props.offer.statistics.dealsCount}
          </BodyText>
        </FlexRow>
        <FlexRow gap={4}>
          <BodyText size={3} scale={'sm'} variation={'darkGray'}>
            Monthly claims:
          </BodyText>
          <BodyText size={3} scale={'sm'}>
            {props.offer.statistics.claimsCount}
          </BodyText>
        </FlexRow>
        <FlexRow gap={4} align={'center'}>
          <StatsLink size={3} scale={'sm'} variation={'darkGray'} onClick={handleOnStatistics}>
            More statistics <SvgIcon src={LinkIcon} size={12} />
          </StatsLink>
        </FlexRow>
      </StyledTableData>
      <StyledTableData align="right">
        <FlexRow gap={15}>
          <StyledSvgIcon src={ViewIcon} size={16} onClick={onViewOffer} />
          <StyledSvgIcon src={EditIcon} size={16} onClick={onEditOffer} />
        </FlexRow>
      </StyledTableData>
    </StyledCardRow>
  );
};
